import { createPortal } from 'react-dom';

import PropTypes from 'prop-types';

import styles from './MobileConfirm.module.scss';

/**
 * 모바일 확인 모달 컴포넌트
 * - 피그마 디자인: 가운데 팝업 스타일
 * - 결재 확인 등에 사용
 */
function MobileConfirm({ isOpen, message, onConfirm, onCancel, confirmText, cancelText }) {
  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div className={styles.backdrop}>
      <div className={styles.modal}>
        {/* 메시지 */}
        <div className={styles.content}>
          <p className={styles.message}>{message}</p>
        </div>

        {/* 버튼 영역 */}
        <div className={styles.buttonGroup}>
          <button type="button" className={styles.cancelButton} onClick={onCancel}>
            {cancelText}
          </button>
          <button type="button" className={styles.confirmButton} onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}

MobileConfirm.propTypes = {
  isOpen: PropTypes.bool,
  message: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
};

MobileConfirm.defaultProps = {
  isOpen: false,
  message: '',
  onConfirm: null,
  onCancel: null,
  confirmText: '예',
  cancelText: '아니오',
};

export default MobileConfirm;
